// import React, { useEffect, useState } from "react";
// import PhotoUploader from "./PhotoUploader";
// import axios from "axios";

// function PhotoAndDetailUploader({ accidentVehicleCode, vendorType, currentService, onClose }) {
//     const [fuelQuantity, setFuelQuantity] = useState("");
//     const [toolingInfo, setToolingInfo] = useState("");
//     const [readOnlyValue, setReadOnlyValue] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [photos1, setPhotos1] = useState([]);
//     const [photos2, setPhotos2] = useState([]);
//     const token = localStorage.getItem("token");
//     const userId = localStorage.getItem("userId");
//     console.log("accidentVehicleCode123", accidentVehicleCode, vendorType, currentService)
//     console.log("fuelQuantity", fuelQuantity, toolingInfo, photos1, photos2)


//     const fetchData = async () => {
//         try {
//             const response = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/toolInfomation/${accidentVehicleCode}`
//             );
//             console.log("getData", response.data.data);

//             if (response.data.data.length > 0) {
//                 console.log('response.data[0].fuelQuantity)', response.data.data[0].fuelQuantity)
//                 setFuelQuantity(response.data.data[0].fuelQuantity);
//                 setToolingInfo(response.data.data[0].toolingInfo);
//                 setPhotos1(response.data.data[0].vehicleImage);
//                 setPhotos2(response.data.data[0].tyresImage);
//                 setReadOnlyValue(true)
//             }
//         }
//         catch (error) {
//             console.error("Error fetching data:", error);
//         }
//     }

//     useEffect(() => {
//         if ((userId.startsWith("CC-") || userId.startsWith("CUD-")) && !readOnlyValue) {
//             fetchData();
//         }
//     }, [userId, readOnlyValue]); // Corrected dependency

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         const photoAndDetails = {
//             photos1,
//             photos2,
//             fuelQuantity,
//             toolingInfo,
//         };
//         console.log("PhotoAndDetails: ", photoAndDetails);
//         const photoAndDetailsObj = new FormData();
//         photos1.forEach((file, index) => {
//             if (file instanceof File) {
//                 console.log('index', index)
//                 photoAndDetailsObj.append(`photos1.${index}`, file);
//             }
//         });
//         console.log('photos2', photos2)
//         photos2.forEach((file, index) => {
//             if (file instanceof File) photoAndDetailsObj.append(`photos2.${index}`, file)
//         });
//         // Append other fields
//         photoAndDetailsObj.append("fuelQuantity", fuelQuantity);
//         photoAndDetailsObj.append("toolingInfo", toolingInfo);
//         console.log('photoAndDetailsObj123', photoAndDetailsObj)
//         for (let pair of photoAndDetailsObj.entries()) {
//             console.log(`${pair[0]}`, pair[1])
//         }
//         let response;
//         try {
//             response = await axios({
//                 method: 'PUT',
//                 url: `${process.env.REACT_APP_BACKEND_URL}/api/vendor-on-accidentvehicle-tools/${userId}/${accidentVehicleCode}/${vendorType}`,
//                 data: photoAndDetailsObj,
//                 headers: {
//                     'Authorization': `Bearer ${token}`
//                 }
//             });
//             setIsLoading(false);
//         } catch (error) {
//             console.error("Error during form submission:", error);
//             const errorMessage = error.response?.data?.message || 'An error occurred';
//         }


//     };

//     const confirmationOnTools = async (action) => {
//         try {
//             setIsLoading(true);
//             let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/customerConfirmationOnTools/${userId}/${accidentVehicleCode}/${action}/${userId}/${currentService}`, {
//                 method: 'PUT',
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Content-Type': 'application/json',
//                 },
//             })
//             if (response.data.status) {
//                 console.log("updated successfully")
//             }
//             setIsLoading(false);
//         }
//         catch (error) {
//             console.log("the error occured", error.message)
//         }
//     }



//     return (
//         <div>
//             <div className="font-satoshi row d-flex justify-content-center align-items-center" style={{ maxWidth: '450px', minWidth: '320px' }}>
//                 <div className="row">
//                     <div className="col text-black">
//                         <PhotoUploader title={"Vehicle Images"} onPhotosChange={setPhotos1} existingPhotos={photos1} userId={userId} />
//                     </div>
//                     <div className="col text-black">
//                         <PhotoUploader title={"Tyres Images"} onPhotosChange={setPhotos2} existingPhotos={photos2} userId={userId} />
//                     </div>
//                     <hr className="mt-1" />
//                 </div>


//                 <div className="flex gap-4 mt-2 ">
//                     <input
//                         type="number"
//                         placeholder="Fuel Quantity"
//                         value={fuelQuantity}
//                         onChange={(e) => setFuelQuantity(e.target.value)}
//                         readOnly={readOnlyValue}
//                         style={{
//                             width: "50%",
//                             padding: "10px",
//                             borderBottom: "1px solid black",
//                             borderRadius: "5px",
//                             color: 'black'
//                         }}
//                     />
//                     <p className="text-semibold text-l mt-3">(Liters)</p>
//                 </div>

//                 <div className="row my-3">
//                     <textarea
//                         placeholder="Tools Summary"
//                         value={toolingInfo}
//                         onChange={(e) => setToolingInfo(e.target.value)}
//                         readOnly={readOnlyValue}
//                         style={{
//                             width: "100%",
//                             minHeight: "140px",
//                             padding: "10px",
//                             border: "1px solid black",
//                             borderRadius: "5px",
//                             resize: "none",
//                             color: 'black'
//                         }}
//                     />
//                 </div>


//                 <div className="flex justify-center w-[90%] fixed bottom-0 left-0 right-0 z-[30] md:relative md:bottom-auto md:left-auto md:right-auto">
//                     {(userId.startsWith('VC-') || userId.startsWith('VED-')) && (
//                         <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
//                             <button className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full" onClick={onClose}>
//                                 Back
//                             </button>
//                             <button className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full bg-[#21A6E9] hover:bg-[#1e94d6]" onClick={handleSubmit}>
//                                 Submit
//                             </button>
//                         </div>
//                     )}
//                     {(userId.startsWith('CC-') || userId.startsWith('CUD')) && (

//                         <div className="mobile-only-shadow flex flex-col items-center justify-between bg-white p-2 mb-[4rem] rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
//                             <button
//                                 className="btn btn-primary w-1/2"
//                                 onClick={() => confirmationOnTools(true)}
//                                 disabled={isLoading}
//                             >
//                             Accept
//                             </button>
//                             <button
//                                 className="btn btn-danger w-1/2"
//                                 onClick={() => confirmationOnTools(false)}
//                                 disabled={isLoading}
//                             >
//                             Decline
//                             </button>
//                             <button
//                                 className="btn btn-danger w-1/2"
//                                 onClick={onClose}
//                                 disabled={isLoading}
//                             >
//                             Close
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default PhotoAndDetailUploader;


import React, { useEffect, useState } from "react";
import PhotoUploader from "./PhotoUploader";
import axios from "axios";
import { Check, X } from 'lucide-react';

import frontRight from '../../../Assets/crane/front-right.jpg';
import frontLeft from '../../../Assets/crane/front-left.jpg';
import rearRight from '../../../Assets/crane/rear-right.jpg';
import rearLeft from '../../../Assets/crane/rear-left.jpg';

import { useModal } from "../../../context/ModalContext.jsx";


function PhotoAndDetailUploader({ accidentVehicleCode, vendorType, currentService, onClose }) {
    const { openModal, modalData, closeModal } = useModal();
    const [activeButton, setActiveButton] = useState(null); // "accept", "decline", or null

    const [fuelQuantity, setFuelQuantity] = useState(0);
    const [toolingInfo, setToolingInfo] = useState("");
    const [readOnlyValue, setReadOnlyValue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [photos1, setPhotos1] = useState([]);
    const [photos2, setPhotos2] = useState([]);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    console.log("accidentVehicleCode123", accidentVehicleCode, vendorType, currentService)
    console.log("fuelQuantity", fuelQuantity, toolingInfo, photos1, photos2)


    const fetchData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/toolInfomation/${accidentVehicleCode}`
            );
            console.log("getData", response.data.data);

            if (response.data.data.length > 0) {
                console.log('response.data[0].fuelQuantity)', response.data.data[0].fuelQuantity)
                setFuelQuantity(response.data.data[0].fuelQuantity);
                setToolingInfo(response.data.data[0].toolingInfo);
                setPhotos1(response.data.data[0].vehicleImage);
                setPhotos2(response.data.data[0].tyresImage);
                setReadOnlyValue(true)
            }
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        if ((userId.startsWith("CC-") || userId.startsWith("CUD-")) && !readOnlyValue) {
            fetchData();
        }
    }, [userId, readOnlyValue]); // Corrected dependency

    const handleSubmitOld = async (e) => {

        console.log('handleSubmit calling: ')

        e.preventDefault();
        setIsLoading(true);
        const photoAndDetails = {
            photos1,
            photos2,
            fuelQuantity,
            toolingInfo,
        };
        console.log("PhotoAndDetails: ", photoAndDetails);
        const photoAndDetailsObj = new FormData();
        photos1.forEach((file, index) => {
            if (file instanceof File) {
                console.log('index', index)
                photoAndDetailsObj.append(`photos1.${index}`, file);
            }
        });
        console.log('photos2', photos2)
        photos2.forEach((file, index) => {
            if (file instanceof File) photoAndDetailsObj.append(`photos2.${index}`, file)
        });
        // Append other fields
        photoAndDetailsObj.append("fuelQuantity", fuelQuantity);
        photoAndDetailsObj.append("toolingInfo", toolingInfo);
        console.log('photoAndDetailsObj123', photoAndDetailsObj)
        for (let pair of photoAndDetailsObj.entries()) {
            console.log(`${pair[0]}`, pair[1])
        }

        console.log(selectedTags)



        // return

        let response;
        try {
            response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/vendor-on-accidentvehicle-tools/${userId}/${accidentVehicleCode}/${vendorType}`,
                data: photoAndDetailsObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            setIsLoading(false);
        } catch (error) {
            console.error("Error during form submission:", error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
        }


    };

    const confirmationOnTools = async (action, type) => {
        try {
            setActiveButton(type);

            const response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/customerConfirmationOnTools/${userId}/${accidentVehicleCode}/${action}/${userId}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.status) {
                console.log("updated successfully");
                onClose(); // ✅ Close modal on success
            }
        } catch (error) {
            console.log("the error occurred", error.message);
        } finally {
            setActiveButton(null);
        }
    };



    const [selectedTags, setSelectedTags] = useState([]);

    const tags = [
        "Jack",
        "Jack Rod",
        "Belt",
        "Rope",
        "Wheels Spanner",
        "Tirpal",
        "Spanners",
        "Tyre Liver",
    ];
    const [rejectedTags, setRejectedTags] = useState([]);

    const toggleTag = (tag) => {
        setSelectedTags((prev) =>
            prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
        );
    };

    const rejectTag = (tag) => {
        setSelectedTags((prev) => prev.filter((t) => t !== tag));
        setRejectedTags((prev) => [...prev, tag]);
    };

    const handleSubmit2 = async (e) => {
        e.preventDefault();

        if (!fuelQuantity || fuelQuantity == '') {
            setFuelQuantity('0')
        }

        setIsLoading(true);

        const combinedToolingInfo = [...selectedTags, toolingInfo].filter(Boolean).join(', ');

        const photoAndDetailsObj = new FormData();

        photos1.forEach((file, index) => {
            if (file instanceof File) {
                photoAndDetailsObj.append(`photos1.${index}`, file);
            }
        });

        photos2.forEach((file, index) => {
            if (file instanceof File) {
                photoAndDetailsObj.append(`photos2.${index}`, file);
            }
        });

        photoAndDetailsObj.append("fuelQuantity", fuelQuantity);
        photoAndDetailsObj.append("toolingInfo", combinedToolingInfo);


        console.log("======= Data going to backend =======");
        for (let [key, value] of photoAndDetailsObj.entries()) {
            if (value instanceof File) {
                console.log(`${key}: [File] name=${value.name}, size=${value.size} bytes`);
            } else {
                console.log(`${key}: ${value}`);
            }
        }

        console.log("=====================================");

        return;

        try {
            const response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/vendor-on-accidentvehicle-tools/${userId}/${accidentVehicleCode}/${vendorType}`,
                data: photoAndDetailsObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log('++++++++++++++++++ Response')
            console.log(response)

            setIsLoading(false);
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Ensure all photos1 are uploaded
        const isPhotos1Complete = photos1.every((photo) => photo && (photo instanceof File || typeof photo === 'string'));

        if (!isPhotos1Complete) {
            alert("Please upload all required vehicle images before submitting.");
            // openModal({
            //     title: 'Error',
            //     body: "Please upload all required vehicle images before submitting.",
            //     iconType: 'error',
            //     autoClose: true,
            // });
            return;
        }

        if (!fuelQuantity || fuelQuantity === '') {
            setFuelQuantity('0');
        }

        setIsLoading(true);

        const combinedToolingInfo = [...selectedTags,...rejectedTags, toolingInfo].filter(Boolean).join(', ');

        const photoAndDetailsObj = new FormData();

        photos1.forEach((file, index) => {
            if (file instanceof File) {
                photoAndDetailsObj.append(`photos1.${index}`, file);
            }
        });

        photos2.forEach((file, index) => {
            if (file instanceof File) {
                photoAndDetailsObj.append(`photos2.${index}`, file);
            }
        });

        photoAndDetailsObj.append("fuelQuantity", fuelQuantity);
        photoAndDetailsObj.append("toolingInfo", combinedToolingInfo);

        console.log("======= Data going to backend =======");
        for (let [key, value] of photoAndDetailsObj.entries()) {
            if (value instanceof File) {
                console.log(`${key}: [File] name=${value.name}, size=${value.size} bytes`);
            } else {
                console.log(`${key}: ${value}`);
            }
        }
        console.log("=====================================");

        // Remove this `return` to allow actual submission

        try {
            const response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/vendor-on-accidentvehicle-tools/${userId}/${accidentVehicleCode}/${vendorType}`,
                data: photoAndDetailsObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log('++++++++++++++++++ Response');
            console.log(response);

            setIsLoading(false);
        } catch (error) {
            console.error("Error during form submission:", error);
            setIsLoading(false);
        }
    };



    return (
        <div>
            <div className="font-satoshi row d-flex justify-content-center align-items-center overflox-y-auto" style={{ Width: '90vw' }}>
                <div className="row">
                    <div className="col text-black">
                        <PhotoUploader
                            title={"Vehicle Images"}
                            onPhotosChange={setPhotos1}
                            existingPhotos={photos1}
                            userId={userId}
                            // placeholderImages={["image1.jpg", "image2.jpg", "image3.jpg", "image4.jpg"]}
                            placeholderImages={[frontRight, frontLeft, rearRight, rearLeft, "", ""]}
                        />
                    </div>
                    <div className="col text-black">
                        <PhotoUploader
                            title={"Tyres Images"}
                            onPhotosChange={setPhotos2}
                            existingPhotos={photos2}
                            userId={userId}
                            placeholderImages={[]}
                        />
                    </div>
                    <hr className="mt-1" />
                </div>


                <div className="row my-3">

                    {(userId.startsWith("VC-") || userId.startsWith("VED-")) && (
                        <div className="mb-4">
                            <p className="text-center text-gray-800 font-medium mb-3">
                                Select from below
                            </p>
                            <div className="flex flex-wrap gap-3">
                                {tags
                                    .filter((tag) => !rejectedTags.includes(tag))
                                    .map((tag) => {
                                        const isSelected = selectedTags.includes(tag);

                                        return (
                                            <div
                                                key={tag}
                                                className={`flex items-center justify-between w-[90vw] border px-3 py-1 rounded-full text-sm font-medium 
          ${isSelected ? "bg-green-100 border-green-500" : "bg-white border-gray-300"}`}
                                            >
                                                <span className="mr-2">{tag}</span>

                                                <div className="flex items-center gap-2">
                                                    {!isSelected ? (
                                                        <>
                                                            <button
                                                                onClick={() => toggleTag(tag)}
                                                                className="text-green-600 hover:text-green-800"
                                                                title="Accept"
                                                            >
                                                                <Check className="w-4 h-4" />
                                                            </button>
                                                            <button
                                                                onClick={() => rejectTag(tag)}
                                                                className="text-red-500 hover:text-red-700"
                                                                title="Reject"
                                                            >
                                                                <X className="w-4 h-4" />
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <Check className="text-green-600 w-4 h-4" />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    )}
                    
                <div className="flex gap-4 mb-2 ">
                    <p className="text-semibold text-l mt-2 w-full mb-2">Fuel in Tank (Liters)</p>

                    <input
                        type="number"
                        placeholder="Fuel Quantity"
                        value={fuelQuantity}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.startsWith('00')) {
                                return
                            }
                            if (value === '' || (/^[0-9]*\.?[0-9]*$/.test(value) && value.length <= 5)) {
                                setFuelQuantity(value);
                            }
                        }}
                        onKeyPress={(e) => {

                            if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}

                        min="0"
                        step="0.1"
                        pattern="[0-9]*\.?[0-9]+"
                        maxLength="5"
                        readOnly={readOnlyValue}
                        style={{
                            width: '50%',
                            padding: '4px',
                            border: '1px solid gray',
                            borderRadius: '5px',
                            color: 'black',
                            textAlign:'center'
                        }}
                    />

                </div>

                    <textarea
                        placeholder="Tools Summary"
                        value={toolingInfo}
                        onChange={(e) => setToolingInfo(e.target.value)}
                        readOnly={readOnlyValue}
                        style={{
                            width: "100%",
                            minHeight: "140px",
                            padding: "10px",
                            border: "1px solid black",
                            borderRadius: "5px",
                            resize: "none",
                            color: 'black'
                        }}
                    />
                </div>


                <div className="flex justify-center w-[90%] fixed bottom-0 left-0 right-0 z-[30] md:relative md:bottom-auto md:left-auto md:right-auto">
                    {(userId.startsWith('VC-') || userId.startsWith('VED-')) && (
                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                            <button
                                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                onClick={onClose}
                                disabled={isLoading} // ✅ disable while loading
                            >
                                Back
                            </button>

                            <button
                                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full bg-[#21A6E9] hover:bg-[#1e94d6] disabled:bg-gray-400"
                                onClick={handleSubmit}
                                disabled={isLoading} // ✅ disable while loading
                            >
                                {isLoading && <span className="spinner-border spinner-border-sm"></span>}
                                {isLoading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    )}
                    {(userId.startsWith('CC-') || userId.startsWith('CUD')) && (

                        <div className="mobile-only-shadow flex flex-col items-center justify-between bg-white p-2 mb-[4rem] rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                            <button
                                className="btn btn-primary w-1/2 flex justify-center items-center gap-2"
                                onClick={() => confirmationOnTools(true, "accept")}
                                disabled={!!activeButton}
                            >
                                {activeButton === "accept" && <span className="spinner-border spinner-border-sm"></span>}
                                Accept
                            </button>

                            <button
                                className="btn btn-danger w-1/2 flex justify-center items-center gap-2"
                                onClick={() => confirmationOnTools(false, "decline")}
                                disabled={!!activeButton}
                            >
                                {activeButton === "decline" && <span className="spinner-border spinner-border-sm"></span>}
                                Decline
                            </button>

                            <button
                                className="btn btn-danger w-1/2 flex justify-center items-center gap-2"
                                onClick={onClose}
                                disabled={!!activeButton}
                            >
                                {activeButton === "close" && <span className="spinner-border spinner-border-sm"></span>}
                                Close
                            </button>
                        </div>


                    )}
                </div>
            </div>
        </div>
    );
}

export default PhotoAndDetailUploader;
